import React from 'react';
import PropTypes from 'prop-types';
import {useLocation} from 'react-router';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import HomeIcon from '@material-ui/icons/Home';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ForumIcon from '@material-ui/icons/Forum';
import Dashboard from '@material-ui/icons/Dashboard';
import Divider from '@material-ui/core/Divider';
import PersonAddIcon from '@material-ui/icons/PersonAdd';
import {Link as RouterLink} from 'react-router-dom';
import MessageIcon from '@material-ui/icons/Message';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import PeopleIcon from '@material-ui/icons/People';
import KeyboardIcon from '@material-ui/icons/Keyboard';
const Navigation = ({auth}) => {
	const location = useLocation();

	return (
		<>
			{auth.isAuth && (
				<>
					<List>
						<ListItem button selected={location.pathname === '/'} component={RouterLink} to={'/'}>
							<ListItemIcon>
								<HomeIcon />
							</ListItemIcon>
							<ListItemText primary={'Home'} />
						</ListItem>
						<ListItem
							button
							selected={location.pathname === '/chat'}
							component={RouterLink}
							to={'/chat'}
						>
							<ListItemIcon>
								<ForumIcon />
							</ListItemIcon>
							<ListItemText primary={'Chat'} />
						</ListItem>
						<ListItem
							button
							selected={location.pathname === '/door'}
							component={RouterLink}
							to={'/door'}
						>
							<ListItemIcon>
								<MeetingRoomIcon />
							</ListItemIcon>
							<ListItemText primary={'Door'} />
						</ListItem>
						<ListItem
							button
							selected={location.pathname === '/keypad'}
							component={RouterLink}
							to={'/keypad'}
						>
							<ListItemIcon>
								<KeyboardIcon />
							</ListItemIcon>
							<ListItemText primary={'Keypad Code'} />
						</ListItem>
						<ListItem
							button
							selected={location.pathname === '/users'}
							component={RouterLink}
							to={'/users'}
						>
							<ListItemIcon>
								<PeopleIcon />
							</ListItemIcon>
							<ListItemText primary={'Members'} />
						</ListItem>
					</List>

					<Divider />

					<List>
						<ListItem
							button
							selected={location.pathname === '/article/add'}
							component={RouterLink}
							to={'/article/add'}
						>
							<ListItemIcon>
								<AddBoxIcon />
							</ListItemIcon>
							<ListItemText primary={'Add article'} />
						</ListItem>

						<ListItem
							button
							selected={location.pathname === '/messages'}
							component={RouterLink}
							to={'/messages'}
						>
							<ListItemIcon>
								<MessageIcon />
							</ListItemIcon>
							<ListItemText primary={'Messages'} />
						</ListItem>
					</List>
				</>
			)}

			{auth.isAdmin && (
				<>
					<Divider />

					<List>
						<ListItem
							button
							selected={location.pathname === '/admin/dashboard'}
							component={RouterLink}
							to={'/admin/dashboard'}
						>
							<ListItemIcon>
								<Dashboard />
							</ListItemIcon>
							<ListItemText primary={'Dashboard'} />
						</ListItem>
						<ListItem
							button
							selected={location.pathname === '/admin/users'}
							component={RouterLink}
							to={'/admin/users'}
						>
							<ListItemIcon>
								<PeopleIcon />
							</ListItemIcon>
							<ListItemText primary={'All Users'} />
						</ListItem>
						<ListItem
							button
							selected={location.pathname === '/admin/addUser'}
							component={RouterLink}
							to={'/admin/addUser'}
						>
							<ListItemIcon>
								<PersonAddIcon />
							</ListItemIcon>
							<ListItemText primary={'Add User'} />
						</ListItem>
					</List>
				</>
			)}
		</>
	);
};

Navigation.propTypes = {
	auth: PropTypes.shape({
		isAuth: PropTypes.bool,
		isAdmin: PropTypes.bool,
	}),
};

export default Navigation;
